var map = {
	"./247-logo-stacked.svg": 1499,
	"./247-logo.svg": 2063,
	"./CarFinance247-logo.svg": 4639,
	"./CarFinance247_logo_purple.svg": 30530,
	"./advantage-logo.svg": 13117,
	"./aldermore-logo.svg": 44297,
	"./alphera-logo.png": 74946,
	"./alphera-logo.svg": 59437,
	"./automoney-logo.jpeg": 37987,
	"./billing-logo.png": 20720,
	"./bluemotor-logo.png": 63890,
	"./bnp-logo.svg": 93144,
	"./close-brothers.svg": 38436,
	"./close-finance-logo.svg": 33683,
	"./credit-agricole-logo.svg": 1328,
	"./lendable-logo.png": 69262,
	"./mobilize-logo.svg": 31727,
	"./moneybarn-logo.webp": 38979,
	"./moneyway-logo.png": 95952,
	"./motonovo-logo.png": 66898,
	"./northridge-logo.png": 13481,
	"./oodle-logo.png": 48294,
	"./specialist-finance-logo.png": 23585,
	"./startline-logo.svg": 2770,
	"./tandem-logo.svg": 7115,
	"./v12-retail-logo.png": 17536,
	"./zopa-logo.svg": 57128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95379;